module.exports = __webpack_public_path__ + "img/lxf.84256bd3.png";